export default "__VITE_ASSET__5da8ffa8__"